module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-url-holder"
  }, [_c('transition', {
    attrs: {
      "name": "section",
      "mode": "out-in",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "url-form"
  }, [_c('form', {
    staticClass: "url-form__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.preloadUrl() && _vm.submit()
      }
    }
  }, [_c('div', {
    staticClass: "form-field__default",
    class: {
      error: !!_vm.urlError
    }
  }, [_c('label', {
    staticClass: "label__default",
    attrs: {
      "for": "url-input"
    }
  }, [_vm._v("\n            Enter Page URL\n            "), (_vm.urlError) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(" - " + _vm._s(_vm.urlError))]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rawUrl),
      expression: "rawUrl"
    }],
    staticClass: "input-field__default",
    attrs: {
      "placeholder": "http://your-bridge-page-link.com"
    },
    domProps: {
      "value": (_vm.rawUrl)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.rawUrl = $event.target.value
      }, _vm.debouceUrl]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-button__addition"
  }, [_c('button', {
    staticClass: "form-button__default form-button__static submit",
    attrs: {
      "disabled": !this.approvedDisclaimer
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.validating && _vm.$store.state.rotator.activeType < 0) ? _c('div', [_vm._v("\n                GO\n              ")]) : _c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])])], 1)]), _vm._v(" "), _c('el-checkbox', {
    model: {
      value: (_vm.approvedDisclaimer),
      callback: function($$v) {
        _vm.approvedDisclaimer = $$v
      },
      expression: "approvedDisclaimer"
    }
  }, [_vm._v("I agree to the stated "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("terms")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("conditions")])])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89a5701e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radius/URL.vue
// module id = 3cfe
// module chunks = 1